import React from 'react';

const Footer = () => {
    return (
        <footer className="footer text-center">
            <p>Made with <span role="img" aria-label="heart">❤️</span> by <a href="https://kristelfung.com/">Kristel Fung</a> & <a href={window.location.host}>ARH</a>.</p>
        </footer>
    )
}

export default Footer;